import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import NoImagePlaceholder from "../../assets/NoImagePlaceholder.png";
import { useAuthContext } from "../../hooks/useAuthContext";
import ProfilePlaceHolder from "../../assets/ProfilePlaceHolder.png";
export default function YouHaveBeenBookedIntoAClass({ notification }) {
  const [club, setClub] = useState(null);
  const formattedDate = new Date(notification.bookingDate).toLocaleDateString();
  const [isLoading, setIsLoading] = useState(true);
  const [event, setEvent] = useState(null);
  const [profile, setProfile] = useState(null);
  const navi = useNavigate();
  const { user } = useAuthContext();
  //styled
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const profileResponse = await axios.get(
        `${ApiConnectionString}/api/BookingProfile/${notification.bookingProfileId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setProfile(profileResponse.data);
      const clubResponse = await axios.get(
        `${ApiConnectionString}/api/club/${notification.clubId}`
      );

      if (clubResponse.status === 200) {
        setClub(clubResponse.data);
      }
      const eventResponse = await axios.get(
        `${ApiConnectionString}/api/event/${notification.eventId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      setEvent(eventResponse.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [user]);

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div className="container text-center bg-white mb-3">
        <div className="blueBanner mt-2">
          <p className=" fw-bold p-2">Booking Confirmation</p>
        </div>
        <p>{notification.content}</p>
        <div className="row">
          <div className="col">
            <div className="lightBlueBanner">
              <p className="fw-bold p-2">Club</p>
            </div>
            <p
              onClick={() => navi(`/myoneclub/${club.id}`)}
              className="fw-bold red-text pointer"
            >
              {club.name}
            </p>
            <div
              onClick={() => navi(`/myoneclub/${club.id}`)}
              className="circle-crop mx-auto"
            >
              <img
                src={
                  club.image
                    ? `${ApiConnectionString}/api/ClubProfileImage/${club.id}`
                    : NoImagePlaceholder
                }
                alt="Club Image"
                className="mt-0 pointer"
              />{" "}
            </div>
          </div>
          <div className="col">
            <div className="lightBlueBanner">
              <p className="fw-bold p-2">Class</p>
            </div>
            <div className="not-static-timetable-wkday">
              <p>{formattedDate}</p>
              <p>{event.day}</p>
            </div>
            <div className="not-static-class-content text-center">
              <p class="fontSize20">{event.name}</p>
              <p class="fontSize12">{event.description}</p>
              <p class="fontSize14">Time in {event.timeIn}</p>
              <p class="fontSize14">Time out {event.timeOut}</p>
            </div>
          </div>
        </div>
        <div>
          <div>
            <div className="lightBlueBanner mt-3 ">
              <p className="fw-bold p-2">Profile</p>
            </div>
            <div className="d-flex justify-content-center">
              <div className="bg-white d-flex justify-content-center profileBox rounded shadow my-3">
                <div>
                  <img
                    src={
                      profile.image
                        ? `${ApiConnectionString}/api/profileImage/${profile.id}`
                        : ProfilePlaceHolder
                    }
                    alt="Profile Image"
                    width={200}
                    className=" m-3 circle-crop"
                  />
                </div>

                <div className="mx-5 mt-5">
                  <p className="red-text">Username</p>
                  <p className="fw-bold mt-2">{profile.username}</p>
                </div>
                <div className="mx-5 mt-5">
                  <p className="red-text">Name</p>
                  <p className="fw-bold">
                    {profile.firstName + " " + profile.lastName}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
